import {ServerModalV3} from "./ServerModalV3";
import {createLocalDatatable, getDatatableComponentsForModal} from "../../datatables";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts file
/**
 * Class based version of initial modalV2
 */
class TableModalV3 extends ServerModalV3 {
	/** @var {TableModalV3Defs.Config} */
	config;

	getTableElement() {
		return this.modalContainer.querySelector('table');
	}

	initDataTable() {
		const tableElement = this.getTableElement();

		if (!tableElement) {
			// No datatable in modal, skip initialization
			return;
		}

		this.tableInstance = createLocalDatatable(
			tableElement,
			this.config.dataTableConfig
		);

		// Move top controls outside main data table wrapper
		const {dataTableFooter, dataTableHeader} = getDatatableComponentsForModal(this.tableInstance)

		this.modalContainer.querySelector('.sub-header-tools').after(dataTableHeader);
		this.modalContainer.querySelector('.modal-footer').appendChild(dataTableFooter)
	}

	init() {
		this.initDataTable();

		// By default call init function from config if set
		if (this.config.init) {
			this.config.init(this);
		}
	}

	display(firstTime) {
		super.display(firstTime);

		// Focus search input after modal is displayed
		setTimeout(() => {
			this.focusSearchInput();
		}, 512)
	}

	getSearchInput() {
		return this.modalContainer.querySelector(
			'.data-table-filter-input-and-length-selector input'
		);
	}

	focusSearchInput() {
		// Wait a bit and focus search input
		const searchInputElement = this.getSearchInput();

		if (searchInputElement) {
			searchInputElement.focus()
		}
	}
}

export {TableModalV3}
